<template>
  <div>
    <v-layout
      v-for="(item, i) in productsList"
      :key="i"
    >
      <v-flex
        md6
        xs12
      >
        <v-select
          v-model.trim="productsList[i].product_id"
          :items="products"
          :item-text="'name'"
          :item-value="'id'"
          :label="$t('modules.ito.products')+'*'"
          :error-messages="product_id_errors[i]"
          @change="validateField('product_id', i)"
          @blur="validateField('product_id', i)"
        />
      </v-flex>
      <v-flex
        md6
        xs12
      >
        <v-text-field
          v-model.trim.number="productsList[i].token_deposit_percent"
          :label="$t('modules.ito.interestAccrual')+'*'"
          suffix="%"
          :error-messages="token_deposit_percent_errors[i]"
          @input="validateField('token_deposit_percent', i)"
          @blur="validateField('token_deposit_percent', i)"
          @keypress="onlyForCurrency($event, productsList[i].token_deposit_percent)"
        >
          <template
            v-slot:append
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('modules.ito.tokenInterestAccrual') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout class="justify-space-between ma-0">
      <v-btn
        outlined
        :disabled="!products"
        @click="addProduct()"
      >
        <v-icon> mdi-plus-circle-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="productsList.length > 0"
        outlined
        @click="removeProduct()"
      >
        <v-icon>  mdi-bucket-outline </v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  requiredIf,
  decimal,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  name: "ProductsITO",
  components: {},
  mixins: [validationMixin],
  props: {
    products: {
      type: Array,
      default: null
    },
    editList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      productsList: [],
      product_id_errors: [],
      token_deposit_percent_errors: [],
    }
  },
  validations() {
    return {
      productsList: {
        $each:{
          product_id: {
            required: requiredIf(() => this.productsList.length !== 0),
          },
          token_deposit_percent: {
            required: requiredIf(function() {
              return this.productsList.length !== 0;
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(100)
          },
        }
      }
    }
  },
  watch: {
    editList(val) {
      if(val && val.length !== 0) {
        this.productsList = val.map((item, idx) => {
          if(item.hasOwnProperty('product')) {
            return {
              product_id: item.product.id,
              token_deposit_percent: item.token_deposit_percent
            }
          }
          this.validateField("product_id", idx);
          this.validateField("token_deposit_percent", idx)
          return item
        });
      }
    },
  },
  methods: {
    validateField(field, i) {
      this.$v.productsList.$each[i][field].$touch()
      const errors = [];
      if (!this.$v.productsList.$each[i][field].$dirty) return;
      this.$v.productsList.$each[i][field].required !== undefined &&
        !this.$v.productsList.$each[i][field].required &&
          errors.push(this.$t("profile.reqField"));
      this.$v.productsList.$each[i][field].decimal !== undefined &&
        !this.$v.productsList.$each[i][field].decimal &&
          errors.push(this.$t("globals.numberField"));
      this.$v.productsList.$each[i][field].minValue !== undefined &&
        !this.$v.productsList.$each[i][field].minValue &&
          errors.push(this.$t("whitelabel.minValueError", {char: this.$v.productsList.$each[i][field].$params.minValue.min}));
      this.$v.productsList.$each[i][field].maxValue !== undefined &&
        !this.$v.productsList.$each[i][field].maxValue &&
          errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.productsList.$each[i][field].$params.maxValue.max}));
      this[`${field}_errors`][i] = errors
    },
    addProduct() {
      this.productsList.push({
          product_id: '',
          token_deposit_percent: ''
        });
    },
    removeProduct() {
      this.productsList.pop();
    },
    save() {
      const productsSave = this.productsList.map(item => {
        return {
          ...item,
          token_deposit_percent: +item.token_deposit_percent
        }
      })
      this.$emit('saveProducts', productsSave);
    }
  },
}
</script>